module.exports = __webpack_public_path__ + "img/home-order.71e97eb7.png";